import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mr-auto flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"height":"var(--header-height)"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AMFFLogo = _resolveComponent("AMFFLogo")
  const _component_AnchorLink = _resolveComponent("AnchorLink")
  const _component_MenuIcon = _resolveComponent("MenuIcon")
  const _component_MobileAsideHeader = _resolveComponent("MobileAsideHeader")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      ref: "header",
      class: ["fixed top-0 left-0 right-0 z-40 transition-all duration-500", { '-top-20': _ctx.hideHeader }]
    }, [
      _createVNode("div", {
        class: ["flex justify-between py-4 px-container items-center", _ctx.y >= 16 ? 'bg-amff-navi' : '']
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_AnchorLink, {
            class: "shrink-0 max-w-xs",
            to: { name: 'home' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AMFFLogo, {
                style: {"width":"12rem","height":"2rem"},
                isSmall: ""
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("button", {
          type: "button",
          class: "ml-auto px-2",
          id: "aria-label-mobile-header",
          "aria-haspopup": "menu",
          "aria-expanded": _ctx.isOpen,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
        }, [
          _createVNode(_component_MenuIcon, {
            class: "w-6 h-6",
            fill: "currentColor",
            "aria-label": "Abrir menú / Obrir menú"
          })
        ], 8, ["aria-expanded"])
      ], 2)
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_MobileAsideHeader, {
          key: 0,
          onClose: _ctx.close
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _hoisted_2
  ], 64))
}